import styled from "styled-components";
import ContentLoader from "react-content-loader";

const BreadCrumbsWrapper = styled.div`
  margin-bottom: 24px;
`;

export const BreadCrumbsLoader = () => (
    <BreadCrumbsWrapper>
        <ContentLoader
            viewBox="0 0 1000 30"
            height="30"
            width="100%"
            speed={2}
            preserveAspectRatio="none"
        >
        <rect x="0" y="5" rx="3" ry="3" width="80" height="20" />
        <rect x="100" y="5" rx="2" ry="2" width="18" height="18" />
        <rect x="130" y="5" rx="3" ry="3" width="120" height="20" />
        <rect x="260" y="5" rx="2" ry="2" width="18" height="18" />
        <rect x="290" y="5" rx="3" ry="3" width="100" height="20" />
        </ContentLoader>
    </BreadCrumbsWrapper>
)